import { ImageUploaderNew } from '../image-uploader-new';

const ImageUploader = (props) => {
  const { uploadCropedImg, index } = props;

  return <ImageUploaderNew {...props} onSave={uploadCropedImg} index={index} />;
};

export default ImageUploader;
